import React, { useCallback, useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-enterprise";
import {
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  MenuItem,
  InputLabel,
  DialogContent,
  DialogTitle,
  Dialog,
  styled,
  Tooltip,
  Menu,
} from "@mui/material";
import { Row, Col, Form } from "react-bootstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InfoIcon from "@mui/icons-material/Info";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import HistoryIcon from "@mui/icons-material/History";

import { DialogProps } from "../../types/SimpleSearchModel";
import {
  downloadFile,
  multipleDownloadFile,
} from "../../api/simpleSearchApi/simpleSearchApi";
import styles from "./ListSearch.module.css";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import "../../config/colors.css";
import ConfirmationDialog from "../SimpleSearch/ConfirmationDialog";
import InfoDrawer from "../SimpleSearch/InfoDrawer";
import { ListFieldModel } from "../../types/ListFieldModel";
import {
  getCompareMetaData,
  getFieldData,
  getFileDownload,
  getListSearchData,
} from "../../api/listSearchAPI/listSearchApi";
import {
  AdvanceDocumentViewObj,
  CompareMetaDataRequestModel,
  FileDownloadRequestModel,
  RequestModel,
} from "../../types/ListSearchModel";
import { UserModel } from "../../types/userDataModel";
import { useLoader } from "../../context/LoaderContext";
import { DownstreamreprocessModel } from "../../types/DownstreamreprocessModel";
import { GetARFDocuments } from "../../api/downstreamSummaryApi/downstreamSummaryApi";
import { ARFDocument } from "../../types/ARFDocumentModel";
import { useSnackbar } from "../Common/SnackbarContext";
import { appSettings } from "../../config/appSetting";
import CustomLoadingOverlay from "../CustomLoadingOverlay/CustomLoadingOverlay ";
import { urlConfig } from "../../config/urlConfig";
import DownstreamFDReprocesspopup from "../Alert/DownstreamFDReprocesspopup";
import DownstreamSubSystemReprocessPopup from "../Alert/DownstreamSubSystemReprocessPopup";
import ConfirmationAlert from "../Alert/ConfirmationAlert";
import AssetHistory from "../Alert/AssetHistory";
import { FormatDate, FormatDateWithoutTime } from "../Common/CommonMethods";
import FileUploads from "../Alert/FileUploads";
import AddNotes from "../Alert/AddNotes";
import RenamePopup from "../Alert/Rename";
import RejectFile from "../Alert/RejectFile";
import MoveToPreflightPopup from "../Alert/MoveToPreflightPopup";
import MoveToFinal from "../Alert/MoveToFinal";
import ReprocessSendToPreflight from "../Alert/ReprocessSendToPreflight";
import isPagePermission from "../../utils/common";
import LocalStorageUtil from "../../utils/localStorage";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

interface Option {
  value: number;
  label: string;
}

interface Category {
  label: string;
  options: Option[];
}

const ListSearch = () => {
  const { showSnackbar } = useSnackbar();
  const { setLoading } = useLoader();
  const [txtSearch, setTxtSearch] = useState("");
  const [resetErrorMsg, setResetErrorMsg] = useState(false);
  const [zipDownload, setZipDownload] = useState(false);
  const [deleteRightShow, setDeleteRightShow] = useState(false);
  const [gridApi, setGridApi] = useState<any>();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [onSearchClick, setOnSearchClick] = useState(false);
  const [loggedUserData, setLoggedUserData] = useState<UserModel | null>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState<any>(null);
  const selectedFieldValueRef = useRef<string | null>(null);
  const selectedFieldTextRef = useRef<string | null>(null);
  const [dialogOpenState, setDialogOpenState] = useState(false);
  const [fields, setFields] = useState<{ key: string; value: string }[]>([]);
  const [thumbnail, setthumbnail] = useState<{ key: string; value: string }[]>(
    []
  );
  const [categories, setCategories] = useState<Category[]>([]);
  const [_isAccountDAOEnabled, setIsAccountDAOEnabled] =
    useState<boolean>(true); // NOSONAR
  const [_isAccountDSAEnabled, setIsAccountDSAEnabled] =
    useState<boolean>(false); // NOSONAR
  const [_isAccountEdeliveryEnabled, setIsAccountEdeliveryEnabled] =
    useState<boolean>(true); // NOSONAR
  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };
  const [selectedFieldValue, setSelectedFieldValue] =
    useState<string>("Select");

  //#region Context Menu
  const [deleteConfirmationDialogOpen, setdeleteConfirmationDialogOpen] =
    useState(false);
  const [deleteDocumentData, setDeleteDocumentData] = useState<any>(null);
  const [isArfMessage, setIsArfMessage] = useState(false);
  const [reprocessSubSystemOpen, setReprocessSubSystemOpen] = useState(false);
  const [reprocessSubSystemOpenData, setReprocessSubSystemOpenData] =
    useState<any>(null);
  const [reprocessFDOpen, setReprocessFDOpen] = useState(false);
  const [reprocessFDOpenData, setReprocessFDOpenData] = useState<any>(null);
  const [reprocessEDeliveryOpen, setReprocessEDeliveryOpen] = useState(false);
  const [reprocessEDeliveryOpenData, setReprocessEDeliveryOpenData] =
    useState<any>(null);
  const [assetHistoryOpen, setAssetHistoryOpen] = useState(false);
  const [assetHistoryData, setAssetHistoryData] = useState<any>(null);
  const [isDateField, setIsDateField] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [QueueType, setQueueType] = useState<number>(2);
  const [showLoader, setShowLoader] = useState(false);
  const [uploadFilesOpen, setUploadFilesOpen] = useState(false);
  const [uploadFilesData, setUploadFilesData] = useState<any>(null);
  const [addNotesOpen, setAddNotesOpen] = useState(false);
  const [addNotesData, setAddNotesData] = useState(false);
  const [renamePopupOpen, setRenamePopupOpen] = useState(false);
  const [renameData, setRenameData] = useState<any>(null);
  const [rejectPopupOpen, setRejectPopupOpen] = useState(false);
  const [rejectData, setRejectData] = useState<any>(null);
  const [moveToPreflightOpen, setMoveToPreflightOpen] = useState(false);
  const [moveToPreflightData, setMoveToPreflightData] = useState<any>(null);
  const [moveToFinalFolderOpen, setMoveToFinalFolderOpen] = useState(false);
  const [moveToFinalFolderData, setMoveToFinalFolderData] = useState<any>(null);
  const [moveToFinalPopupTitle, setMoveToFinalPopupTitle] =
    useState<string>("");
  const [reprocessSendToPreflightOpen, setReprocessSendToPreflightOpen] =
    useState(false);
  const [reprocessSendToPreflightData] = useState<any>(null);
  const [documentStatusValue] = useState<number>(0);
  const [contextMenuType, setContextMenuType] = useState<number>(1);

  const handleFieldChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newField = event.target.value;
    const selectedText = event.target.options[event.target.selectedIndex].text;
    selectedFieldValueRef.current = newField;
    selectedFieldTextRef.current = selectedText;
    if (selectedText.includes("Date")) {
      setIsDateField(true);
    } else {
      setIsDateField(false);
    }
    setSelectedFieldValue(newField);
  };

  const [dialogProps, setDialogProps] = useState<DialogProps>({
    dialogTitle: "",
    contentText: "",
    confirmText: "",
    closeText: "",
    onConfirm: null,
  });

  const txtSearchRef = useRef(txtSearch);
  const isSearchClicked = useRef(onSearchClick);
  const gridRef = useRef<AgGridReact>(null);

  const [rowData, setRowData] = useState<any[]>([]);
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);
  const [_gridRecordExist, setGridRecordExist] = useState(false); // NOSONAR

  const pageSizeSelector = appSettings.agGridPageSizeSelector;
  const defaulPageSize = appSettings.agGridDefaulPageSize;

  useEffect(() => {
    txtSearchRef.current = txtSearch;
    isSearchClicked.current = onSearchClick;
  }, [txtSearch, onSearchClick]);

  useEffect(() => {
    getField();
    getLoogedUserData();
  }, []);

  const getField = async () => {
    setLoading(true);
    const params: ListFieldModel = {
      accountId: Number(LocalStorageUtil.getItem("accountId")) || 0, // AccountId from local storage
      contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
    };
    try {
      const response = await getFieldData(params);
      const transformedData = transformData(response);
      setCategories(transformedData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const transformData = (data: any[]): Category[] => {
    const categoryMap: { [key: string]: Category } = {};

    data.forEach((item) => {
      const { categoryName, fieldMappingId, field } = item;

      if (!categoryMap[categoryName]) {
        categoryMap[categoryName] = {
          label: categoryName,
          options: [],
        };
      }

      categoryMap[categoryName].options.push({
        value: fieldMappingId,
        label: field,
      });
    });
    return Object.values(categoryMap);
  };

  const thumbnailCellRenderer = (params: any) => {
    if (params.data === undefined) {
      return "";
    } else {
      const rowData = params.data;
      if (!rowData.Thumbnail) {
        return <p style={{ marginLeft: "2em" }}>N/A</p>;
      } else {
        return (
          <img
            src={rowData.Thumbnail}
            className="img-responsive"
            alt=""
            width="50px"
            height="50px"
            style={{ margin: "15px" }}
          />
        );
      }
    }
  };
  //History - Action buttons events
  const viewHistory = (rowData: any) => {
    setAssetHistoryData(rowData);
    setAssetHistoryOpen(true);
  };

  // Close AssetHistory
  const closeAssetHistory = () => {
    setAssetHistoryOpen(false);
    setAssetHistoryData(null);
  };

  // Helper function to determine if status should be excluded
  const isExcludedStatus = (status: number): boolean => {
    const excludedStatuses = [
      3, 6, 11, 17, 18, 20, 21, 23, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34, 35,
    ];
    return excludedStatuses.includes(status);
  };

  // Helper function to check if status allows reject
  const canReject = (status: number): boolean => {
    const nonRejectableStatuses = [
      6, 11, 17, 18, 20, 23, 24, 27, 28, 30, 31, 32, 33, 34, 35,
    ];
    return !nonRejectableStatuses.includes(status);
  };

  // Helper function to render prework menu items
  const renderPreworkMenuItems = (rowData: any, handleClose: any) => {
    const status = Number(rowData.DocumentStatus);

    return [
      // Upload
      isPagePermission("Allow Download", "ListSearch", 54) &&
        !isExcludedStatus(status) && (
          <MenuItem
            key={`upload-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(5, rowData)}
          >
            Upload
          </MenuItem>
        ),

      // Add Notes
      isPagePermission("Allow Add Notes", "ListSearch") &&
        rowData.DocumentStatus !== "20" && (
          <MenuItem
            key={`add-notes-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(6, rowData)}
          >
            Add Notes
          </MenuItem>
        ),

      // Move to Preflight
      isPagePermission("Allow Move To Preflight", "ListSearch", 1394) &&
        rowData.DocumentStatus === "2" && (
          <MenuItem
            key={`move-to-preflight-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(7, rowData)}
          >
            Move to Preflight
          </MenuItem>
        ),

      // Reprocess to Preflight
      isPagePermission("Allow Reprocess - To Preflight", "ListSearch", 1432) &&
        rowData.DocumentStatus === "6" && (
          <MenuItem
            key={`reprocess-to-preflight-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(8, rowData)}
          >
            Reprocess to Preflight
          </MenuItem>
        ),

      // Trigger Proof WF
      isPagePermission("TriggerProofFlow", "ListSearch", 1399) &&
        (rowData.DocumentStatus === "2" ||
          rowData.DocumentStatus === "11" ||
          rowData.DocumentStatus === "18") && (
          <MenuItem
            key={`trigger-proof-wf-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(9, rowData)}
          >
            Trigger Proof WF
          </MenuItem>
        ),

      // Trigger Prod WF
      isPagePermission("Allow TriggerProdFlow", "ListSearch", 1429) &&
        (rowData.DocumentStatus === "11" ||
          rowData.DocumentStatus === "18") && (
          <MenuItem
            key={`trigger-prod-wf-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(10, rowData)}
          >
            Trigger Prod WF
          </MenuItem>
        ),

      // To Final Folder (Status 11)
      isPagePermission("Allow Move To Final Folder", "ListSearch", 1430) &&
        rowData.DocumentStatus === "11" && (
          <MenuItem
            key={`to-final-folder-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(11, rowData)}
          >
            To Final Folder
          </MenuItem>
        ),

      // To Final Folder (Status 18)
      isPagePermission("Allow Move To Final Folder Vis", "ListSearch", 1431) &&
        rowData.DocumentStatus === "18" && (
          <MenuItem
            key={`to-final-folder-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(12, rowData)}
          >
            To Final Folder
          </MenuItem>
        ),

      // Rename
      isPagePermission("Allow Rename", "ListSearch", 53) &&
        !isExcludedStatus(status) && (
          <MenuItem
            key={`rename-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(14, rowData)}
          >
            Rename
          </MenuItem>
        ),

      // Reject
      isPagePermission("Allow Reject", "ListSearch", 1397) &&
        canReject(status) && (
          <MenuItem
            key={`reject-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(15, rowData)}
          >
            Reject
          </MenuItem>
        ),
    ];
  };

  // Helper function to render downstream menu items
  const renderDownstreamMenuItems = (rowData: any, handleClose: any) => {
    return [
      rowData.IsAllowSubSystemReprocess === "True" &&
        rowData["ACTION CODE"] !== "ARF" &&
        isPagePermission("", "", 1447) &&
        LocalStorageUtil.getItem("contextName") !== "DocDistro_MOAForms" && (
          <MenuItem
            key={`reprocess-to-source-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(1, rowData)}
          >
            Reprocess to Source
          </MenuItem>
        ),

      rowData.Rendition_Intern?.toUpperCase() ===
        "CURRENT (PRINT-READY VERSION)" &&
        isPagePermission("Allow Send to Preflight", "ListSearch", 1349) && (
          <MenuItem
            key={`send-to-preflight-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(2, rowData)}
          >
            Send to Preflight
          </MenuItem>
        ),

      isPagePermission("Allow Send to Downsample", "ListSearch", 1350) &&
        ((rowData.DocumentStatus === "2" &&
          rowData.Rendition_Intern?.toUpperCase() ===
            "CURRENT (PRINT-READY VERSION)") ||
          rowData.Rendition_Intern.toUpperCase() === "CURRENT") && (
          <MenuItem
            key={`send-to-downsample-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(3, rowData)}
          >
            Send to Downsample
          </MenuItem>
        ),

      isPagePermission("Allow Send to Edelivery", 1354) &&
        rowData.Rendition_Intern?.toUpperCase() === "CURRENT" && (
          <MenuItem
            key={`send-to-edelivery-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(4, rowData)}
          >
            Send to E-delivery
          </MenuItem>
        ),
    ];
  };

  const ActionCellRenderer = (params: any) => {
    const { QueueType } = params.context;
    const rowData = params.data;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: any) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = (actionType: number, rowData: any) => {
      // Delete
      if (actionType === 0) {
        handelDeleteContextMenuOption(rowData);
      }
      // Reprocess to Source
      else if (actionType === 1) {
        handleReprocessTosource(rowData);
      }
      // Send to preflight OR Send to downsample
      else if (actionType === 2 || actionType === 3) {
        handleSendToPreflight_SendToDownSample(rowData);
      }
      // Send to E-delivery
      else if (actionType === 4) {
        handleSendToEDelivery(rowData);
      } else if (actionType === 5) {
        //Upload
        handelUploadFiles(rowData, 1);
      } else if (actionType === 6) {
        //Add Notes
        handleAddNotes(rowData);
      } else if (actionType === 7) {
        //Reprocess to Preflight
        moveToPreflight(rowData, 0);
      } else if (actionType === 9) {
        // Trigger Proof WF
        moveToFinalFolder(rowData, 0, 2);
      } else if (actionType === 10) {
        // Trigger Prod WF
        moveToFinalFolder(rowData, 0, 3);
      } else if (actionType === 11 || actionType === 12) {
        //To Final Folder
        moveToFinalFolder(rowData, 0, 1);
      } else if (actionType === 14) {
        //Rename
        handleRename(rowData, false);
      } else if (actionType === 15) {
        //Reject
        handleReject(rowData);
      }

      setAnchorEl(null);
    };

    if (params.data === undefined) {
      return "";
    }

    return (
      <div>
        {isPagePermission("Allow Download", "ListSearch", 54) && (
          <Tooltip title="Click here to download the documents">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => fileDownload(rowData)}
            >
              <FileDownloadIcon />
            </IconButton>
          </Tooltip>
        )}
        {isPagePermission("Allow DocumentPreView", "ListSearch", 55) && (
          <Tooltip title="Click to view">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => viewDocument(rowData)}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        )}
        {isPagePermission("Allow Metadata Information", "ListSearch", 1347) && (
          <Tooltip title="Click to view the file information and history">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => infoDocument(rowData)}
            >
              <InfoIcon />
            </IconButton>
          </Tooltip>
        )}
        {isPagePermission("Allow Asset History", "ListSearch") && (
          <Tooltip title="Click to view Asset History">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => viewHistory(rowData)}
              data-testid="asset-history-button"
              id="asset-history-button"
              aria-label="Click to view Asset History"
            >
              <HistoryIcon />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title="Please click to view the actions">
          <MoreVertIcon
            className="icon-button"
            data-testid={`primary-action`}
            onClick={handleClick}
            style={{
              padding: "0.2vh",
              cursor: "pointer",
            }}
          />
        </Tooltip>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          keepMounted
        >
          {isPagePermission("Allow Delete", "ListSearch", 56) && (
            <MenuItem
              key={`delete-${rowData.DocumentStreamID}`}
              className="context-menu-item"
              onClick={() => handleClose(0, rowData)}
              data-testid={`delete-action`}
            >
              Delete
            </MenuItem>
          )}
          {QueueType === 2 && renderDownstreamMenuItems(rowData, handleClose)}
          {QueueType === 1 && renderPreworkMenuItems(rowData, handleClose)}
        </Menu>
      </div>
    );
  };

  // Helper function to build ARFDocument from a row
  function buildArfDocument(row: any): ARFDocument {
    return {
      ProjectDocumentIds: row["Document ID"],
      ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
      AccountId: Number(LocalStorageUtil.getItem("accountId")),
      DocumentStreamId: row["DocumentStreamID"],
      UserId: Number(LocalStorageUtil.getItem("userId")),
    };
  }

  // Helper function to handle ARF document response
  async function handleArfDocumentCheck(
    arfDocuments: ARFDocument[],
    actionCode: string,
    setDeleteDocumentData: (docs: ARFDocument[]) => void,
    setdeleteConfirmationDialogOpen: (open: boolean) => void,
    setIsArfMessage: (isArf: boolean) => void
  ) {
    if (arfDocuments.length === 0) return;

    if (actionCode?.toLowerCase() !== "arf") {
      const arfDocumentResponse = await GetARFDocuments(arfDocuments);
      setDeleteDocumentData(arfDocuments);
      setdeleteConfirmationDialogOpen(true);
      setIsArfMessage(arfDocumentResponse === true);
    } else {
      setDeleteDocumentData(arfDocuments);
      setdeleteConfirmationDialogOpen(true);
      setIsArfMessage(false);
    }
  }

  // Helper function to process selected rows
  function processSelectedRows(selectedRows: any): {
    arfDocuments: ARFDocument[];
    actionCode: string;
  } {
    const arfDocuments: ARFDocument[] = [];
    let actionCode = "";

    if (Array.isArray(selectedRows)) {
      actionCode = selectedRows[0]?.["ACTION CODE"] ?? "";
      selectedRows.forEach((row) => {
        arfDocuments.push(buildArfDocument(row));
      });
    } else if (selectedRows) {
      actionCode = selectedRows["ACTION CODE"] ?? "";
      arfDocuments.push(buildArfDocument(selectedRows));
    }

    return { arfDocuments, actionCode };
  }

  // Refactored function
  const handelDeleteContextMenuOption = async (rowsData: any) => {
    try {
      setLoading(true);

      if (!gridRef.current) return;

      let selectedRows = gridRef.current.api.getSelectedRows();
      selectedRows = selectedRows.length > 0 ? selectedRows : rowsData;

      if (selectedRows.length === undefined || selectedRows.length === 0) {
        showSnackbar("Please check any one checkbox", true);
        setLoading(false);
        return;
      }

      const { arfDocuments, actionCode } = processSelectedRows(selectedRows);

      if (arfDocuments.length > 0) {
        await handleArfDocumentCheck(
          arfDocuments,
          actionCode,
          setDeleteDocumentData,
          setdeleteConfirmationDialogOpen,
          setIsArfMessage
        );
      }
    } catch (ex) {
      console.error("Error in handelDeleteContextMenuOption:", {
        error: ex,
        rowsData,
      });
    } finally {
      setLoading(false);
    }
  };

  //Handel reprocess to source
  const handleReprocessTosource = async (rowsData: any) => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      let downstreamrReprocessModel: DownstreamreprocessModel[] = [];
      if (selectedRows.length === 0) {
        const objDownstreamreprocessModel: DownstreamreprocessModel = {
          ProcessType: undefined,
          DocumentStreamId: rowsData.DocumentStreamID,
          AccountId: loggedUserData?.accountId,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          FileName: rowsData.DownloadFileName,
          Serverpath: undefined,
          DocumentLink: undefined,
          Recipients: undefined,
          CCEmail: undefined,
          Subject: undefined,
          SubSystemConfigurationID:
            rowsData.SubSystemConfigurationId.toString() ?? "",
          ParentDocumentStreamID: rowsData.ParentDocumentStreamID.toString(),
          SubSystemName: rowsData.SubSystemName.toString(),
          BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
          DocumentStatus: rowsData.DocumentStatus,
          TimeZone: "Central America Standard Time",
        };
        downstreamrReprocessModel.push(objDownstreamreprocessModel);
      } else {
        selectedRows.forEach((rowData) => {
          const objDownstreamreprocessModel: DownstreamreprocessModel = {
            ProcessType: undefined,
            DocumentStreamId: rowData.DocumentStreamID,
            AccountId: loggedUserData?.accountId,
            UserId: Number(LocalStorageUtil.getItem("userId")),
            FileName: rowData.DownloadFileName,
            Serverpath: undefined,
            DocumentLink: undefined,
            Recipients: undefined,
            CCEmail: undefined,
            Subject: undefined,
            SubSystemConfigurationID:
              rowsData.SubSystemConfigurationId.toString() ?? "",
            ParentDocumentStreamID: rowsData.ParentDocumentStreamID.toString(),
            SubSystemName: rowsData.SubSystemName.toString(),
            BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
            ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
            DocumentStatus: rowData.DocumentStatus,
            TimeZone: "Central America Standard Time",
          };
          downstreamrReprocessModel.push(objDownstreamreprocessModel);
        });
      }
      if (
        downstreamrReprocessModel !== undefined &&
        downstreamrReprocessModel.length > 0
      ) {
        setReprocessSubSystemOpenData(downstreamrReprocessModel);
        setReprocessSubSystemOpen(true);
      } else {
        showSnackbar("No document selected to reprocess", true);
      }
    }
  };

  //Handel send to preflight and send to downsample
  const handleSendToPreflight_SendToDownSample = async (rowsData: any) => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      let downstreamrReprocessModel: DownstreamreprocessModel[] = [];
      if (selectedRows.length === 0) {
        const objDownstreamreprocessModel: DownstreamreprocessModel = {
          ProcessType: undefined,
          DocumentStreamId: rowsData.DocumentStreamID,
          AccountId: loggedUserData?.accountId,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          FileName: rowsData.DownloadFileName,
          Serverpath: undefined,
          DocumentLink: undefined,
          Recipients: undefined,
          CCEmail: undefined,
          Subject: undefined,
          SubSystemConfigurationID: undefined,
          ParentDocumentStreamID: undefined,
          SubSystemName: undefined,
          BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
          DocumentStatus: rowsData.DocumentStatus,
          TimeZone: "Central America Standard Time",
        };
        downstreamrReprocessModel.push(objDownstreamreprocessModel);
      } else {
        selectedRows.forEach((rowData) => {
          const objDownstreamreprocessModel: DownstreamreprocessModel = {
            ProcessType: undefined,
            DocumentStreamId: rowData.DocumentStreamID,
            AccountId: loggedUserData?.accountId,
            UserId: Number(LocalStorageUtil.getItem("userId")),
            FileName: rowData.DownloadFileName,
            Serverpath: undefined,
            DocumentLink: undefined,
            Recipients: undefined,
            CCEmail: undefined,
            Subject: undefined,
            SubSystemConfigurationID: undefined,
            ParentDocumentStreamID: undefined,
            SubSystemName: undefined,
            BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
            ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
            DocumentStatus: rowData.DocumentStatus,
            TimeZone: "Central America Standard Time",
          };
          downstreamrReprocessModel.push(objDownstreamreprocessModel);
        });
      }
      if (
        downstreamrReprocessModel !== undefined &&
        downstreamrReprocessModel.length > 0
      ) {
        setReprocessFDOpenData(downstreamrReprocessModel);
        setReprocessFDOpen(true);
      } else {
        showSnackbar("No FD document selected to reprocess", true);
      }
    }
  };

  //Handel send to e-delivery
  const handleSendToEDelivery = async (rowsData: any) => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      let downstreamrReprocessModel: DownstreamreprocessModel[] = [];
      if (selectedRows.length === 0) {
        const objDownstreamreprocessModel: DownstreamreprocessModel = {
          ProcessType: undefined,
          DocumentStreamId: rowsData.DocumentStreamID,
          AccountId: loggedUserData?.accountId,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          FileName: rowsData.DownloadFileName,
          Serverpath: undefined,
          DocumentLink: undefined,
          Recipients: undefined,
          CCEmail: undefined,
          Subject: undefined,
          SubSystemConfigurationID: undefined,
          ParentDocumentStreamID: undefined,
          SubSystemName: undefined,
          BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
          DocumentStatus: rowsData.DocumentStatus,
          TimeZone: "Central America Standard Time",
        };
        downstreamrReprocessModel.push(objDownstreamreprocessModel);
      } else {
        selectedRows.forEach((rowData) => {
          const objDownstreamreprocessModel: DownstreamreprocessModel = {
            ProcessType: undefined,
            DocumentStreamId: rowData.DocumentStreamID,
            AccountId: loggedUserData?.accountId,
            UserId: Number(LocalStorageUtil.getItem("userId")),
            FileName: rowData.DownloadFileName,
            Serverpath: undefined,
            DocumentLink: undefined,
            Recipients: undefined,
            CCEmail: undefined,
            Subject: undefined,
            SubSystemConfigurationID: undefined,
            ParentDocumentStreamID: undefined,
            SubSystemName: undefined,
            BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
            ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
            DocumentStatus: rowData.DocumentStatus,
            TimeZone: "Central America Standard Time",
          };
          downstreamrReprocessModel.push(objDownstreamreprocessModel);
        });
      }
      if (
        downstreamrReprocessModel !== undefined &&
        downstreamrReprocessModel.length > 0
      ) {
        setReprocessEDeliveryOpenData(downstreamrReprocessModel);
        setReprocessEDeliveryOpen(true);
      } else {
        showSnackbar("No FD document selected to reprocess", true);
      }
    }
  };

  //Rename the columns
  const renameColumns = (val: any) => {
    if (val !== undefined) {
      if (val?.toLowerCase() === "ngfamily_id") {
        return "Family_Id";
      } else if (val?.toLowerCase() === "statement_date") {
        return "Date";
      } else if (val?.toLowerCase() === "sub_dob") {
        return "DateOfBirth";
      } else if (val?.toLowerCase() === "sub_name") {
        return "Name";
      } else if (val?.toLowerCase() === "dao flag") {
        return "DAO Flag";
      } else if (val?.toLowerCase() === "level 1") {
        return "Rendition";
      } else if (val?.toLowerCase() === "lastmodifieddate") {
        return "Last Modified Date";
      } else {
        return val?.replace(/&amp;/, "&");
      }
    }
  };

  // Fetch data from API
  const fetchData = async (params: any) => {
    try {
      setShowLoader(true);
      const response = await getListSearchData(params);
      const { listSearchModel = [], recordCount = 0 } = response;
      if (listSearchModel && listSearchModel.length > 0) {
        // Define columns to exclude
        const columnsToExclude = [
          "RowNum",
          "FileType",
          "DocumentID",
          "DocumentStreamID",
          "DocumentStatus",
          "QueueType",
          "RecordCounts",
          "latestDocumentDesc",
          "FromPreflightJobNumber",
          "ToPreflightJobNumber",
          "RejectRemarks",
          "FinalDocID",
          "ProjectDocumentId",
          "agentFirstName",
          "agentLastName",
          "RenameRemarks",
          "ResolutionStatus",
          "ParentDocumentStreamID",
          "DocumentStatus",
          "Thumbnail",
          "Rendition_Intern",
          "fileSize",
          "Field",
          "ToPreflightZipName",
          "rendition_Intern",
          "AccessPermission",
          "PreworkDynamicFilename",
          "ChildAcceptedId",
          "ChildFileUploadedon",
          "ChildFileAcceptedDate",
          "daoflag_Intern",
          "daoflag",
          "DownloadFileName",
          "RecordCountsTemp",
          "IsAllowSubSystemReprocess",
          "SubSystemName",
          "SubSystemConfigurationId",
        ];

        // Dynamically get column headers from the data
        const dynamicColumns = Object.keys(listSearchModel[0])
          .filter((key) => !columnsToExclude.includes(key))
          .map((key) => {
             if (
              (key.toLowerCase().includes("date") &&
                key.toLowerCase() !== "document date") ||
              key.toLowerCase() === "uploaded on" ||
              key.toLowerCase() === "aws date"
            ) {
              return {
                headerName: renameColumns(
                  key.charAt(0).toUpperCase() + key.slice(1),
                ),
                field: key,
                sortable: true,
                filter: true,
                enableRowGroup: true,
                valueFormatter: (params: any) => {
                  if (
                    key.toLowerCase() === "supplement date" ||
                    key.toLowerCase() === "revised date" ||
                    key.toLowerCase() === "amendment date"
                  ) {
                    return FormatDateWithoutTime(params.value);
                  }
                  return FormatDate(params.value);
                },
              };
            } else {
              return {
                headerName: renameColumns(
                  key.charAt(0).toUpperCase() + key.slice(1),
                ),
                field: key,
                sortable: true,
                filter: true,
                enableRowGroup: true,
              };
            }
          });

        // Combine static and dynamic column definitions
        const combinedColumnDefs = [
          {
            width: 10,
            sortable: false,
            filter: false,
            hide: false,
            colId: "colCheckbox",
            enableRowGroup: false,
            resizable: false,
          },
          {
            headerName: "#",
            width: 70,
            colId: "colRowNum",
            sortable: false,
            filter: false,
            resizable: false,
            enableRowGroup: false,
            valueGetter: (params: any) => {
              return params.node ? (params.node.rowIndex ?? 0) + 1 : 0;
            },
          },
          {
            headerName: "Thumbnail",
            field: "Thumbnail",
            cellRenderer: thumbnailCellRenderer,
            width: 150,
            autoHeight: true,
            sortable: false,
            enableRowGroup: false,
          },
          ...dynamicColumns,
          {
            field: "Actions",
            headerName: "Actions",
            sortable: false,
            enableRowGroup: false,
            pinned: "right" as const,
            lockPinned: true,
            suppressSizeToFit: true,
            width: 160,
            minWidth: 160,
            cellClass: "actions-button-cell",
            cellRenderer: ActionCellRenderer,
            filter: false,
            resizable: false,
            colId: "colAction",
          },
        ];
        setColumnDefs(combinedColumnDefs);

        let documentId: any[] = [];
        listSearchModel.forEach((item: any) => {
          documentId.push(item.DocumentID);
        });
        try {
          const advanceDocumentViewObj: AdvanceDocumentViewObj = {
            contextName: (
              LocalStorageUtil.getItem("contextName") ?? ""
            ).toString(),
          };
          const thumbnailPayload: FileDownloadRequestModel = {
            AdvanceDocumentViewObj: advanceDocumentViewObj,
            fileObj: documentId,
          };
          const thumbnailData = await getFileDownload(thumbnailPayload);
          const { objSearch = [] } = thumbnailData;

          if (objSearch?.searchViewStaticModel != null) {
            listSearchModel.forEach((listItem: any, index: number) => {
              objSearch.searchViewStaticModel.forEach((documentItem: any) => {
                if (
                  Number(listItem.DocumentID) === documentItem.documentStreamID
                ) {
                  listSearchModel[index].Thumbnail = documentItem.thumbnail
                    ? `data:image/jpeg;base64,${documentItem.thumbnail}`
                    : null;
                }
              });
            });
          }
          showSnackbar(listSearchModel.length + " Records found");
        } catch (error) {}

        setZipDownload(true);
        setDeleteRightShow(true);
        setOnSearchClick(false);
        setRowData(listSearchModel);
      } else {
        setColumnDefs([]);
        setRowData([]);
        setGridRecordExist(false);
      }
    } catch (error) {
      showSnackbar("Internal server error", true);
    } finally {
      setShowLoader(false);
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setResetErrorMsg(false);
    setTxtSearch(e.target.value);
  };

  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: appSettings.timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const formatDate = (date: any) => {
    if (!date) return null;
    const parts = formatter.formatToParts(date).reduce((acc: any, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});
    return `${parts.month}/${parts.day}/${parts.year}`;
  };

  const handleSearchSubmit = useCallback(
    async (e?: React.FormEvent) => {
      if (e) {
        e.preventDefault();
      }
      if (!isDateField && txtSearch === "") {
        setResetErrorMsg(true);
        return;
      }
      setRowData([]);
      const payload: RequestModel = {
        sortOrder: 0,
        sortColumn: null,
        currentPage: 0,
        noOfRecords: 0,
        searchText: !isDateField
          ? txtSearchRef.current
          : formatDate(startDate) ?? "",
        accountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
        userId: Number(LocalStorageUtil.getItem("userId")),
        isSuperAdmin: Number(LocalStorageUtil.getItem("isSuperAdmin")),
        folderRights: "False",
        contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
        queueType: QueueType,
        isPdfSplitEnabled: "False",
        isAccountDAOEnabled: "False",
        isAccountDSAEnabled: "False",
        isNoSubProcessEnabled: "False",
        MetadataFieldId: Number(selectedFieldValueRef.current),
        metadataFieldName: selectedFieldTextRef.current ?? "",
        offSet: appSettings.timezone,
      };

      fetchData(payload);

      setOnSearchClick(true);

      if (gridApi) {
        gridApi.onFilterChanged();
      }
    },
    [txtSearch, gridApi, startDate, isDateField, QueueType]
  );

  const resetGridData = () => {
    const payload: RequestModel = {
      sortOrder: 0,
      sortColumn: null,
      currentPage: 0,
      noOfRecords: 0,
      searchText: txtSearchRef.current,
      accountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
      userId: Number(LocalStorageUtil.getItem("userId")),
      isSuperAdmin: Number(LocalStorageUtil.getItem("isSuperAdmin")),
      folderRights: "False",
      contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
      queueType: QueueType,
      isPdfSplitEnabled: "False",
      isAccountDAOEnabled: "False",
      isAccountDSAEnabled: "False",
      isNoSubProcessEnabled: "False",
      MetadataFieldId: 0,
      metadataFieldName: "",
      offSet: appSettings.timezone,
    };
    setQueueType(2);
    fetchData(payload);
  };

  const getLoogedUserData = async () => {
    try {
      const userData = LocalStorageUtil.getItem("authorizationData");
      if (userData) {
        setLoggedUserData(JSON.parse(userData));
        setIsAccountDAOEnabled(loggedUserData?.isAccountDAOEnabled === "True");
        setIsAccountDSAEnabled(loggedUserData?.isAccountDSAEnabled === "True");
        setIsAccountEdeliveryEnabled(
          loggedUserData?.isAccountEdeliveryEnabled === "True"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleReset = () => {
    setTxtSearch("");
    setZipDownload(false);
    setDeleteRightShow(false);
    setSelectedFieldValue("Select");
    resetGridData();
    setRowData([]);
  };

  const clearSelectedRows = () => {
    gridRef.current!.api.deselectAll();
  };

  const deleteSelectetdDocuments = async () => {
    if (!gridRef.current) return;
    let selectedRows = gridRef.current.api.getSelectedRows();
    if (selectedRows.length === 0) {
      showSnackbar("Please select one or more documents to delete.", true);
      return;
    }

    // Helper to build ARFDocument array from rows
    const buildArfDocuments = (rows: any[]): ARFDocument[] =>
      rows.map((row) => ({
        ProjectDocumentIds: row["Document ID"],
        ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
        AccountId: Number(LocalStorageUtil.getItem("accountId")),
        DocumentStreamId: row["DocumentStreamID"],
        UserId: Number(LocalStorageUtil.getItem("userId")),
      }));

    // Normalize selectedRows to array
    let rowsArray: any[];
    if (Array.isArray(selectedRows)) {
      rowsArray = selectedRows;
    } else if (selectedRows) {
      rowsArray = [selectedRows];
    } else {
      rowsArray = [];
    }

    if (rowsArray.length === 0) {
      console.log("No document selected to delete");
      return;
    }
    const actionCode =
      (rowsArray[0] as Record<string, any>)["ACTION CODE"]?.toLowerCase?.() ??
      (selectedRows as Record<string, any>)["ACTION CODE"]?.toLowerCase?.();

    // If actionCode is not 'arf', proceed with ARF logic
    if (actionCode !== "arf") {
      const arfDocuments = buildArfDocuments(rowsArray);
      if (arfDocuments.length > 0) {
        const arfDocumentResponse = await GetARFDocuments(arfDocuments);
        setDeleteDocumentData(arfDocuments);
        setdeleteConfirmationDialogOpen(true);
        setIsArfMessage(arfDocumentResponse === true);
      }
      return;
    }

    // If actionCode is 'arf', handle single/multiple selection
    const arfDocuments = buildArfDocuments(rowsArray);
    if (arfDocuments.length > 0) {
      setDeleteDocumentData(arfDocuments);
      setdeleteConfirmationDialogOpen(true);
      setIsArfMessage(false);
    }
  };

  const downloadSelectedFiles = () => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      if (selectedRows.length > 1) {
        showSnackbar("Download started ...");
        let documentStreamID: number[] = [];

        selectedRows.forEach((item: any) => {
          documentStreamID.push(item.DocumentStreamID);
        });

        if (documentStreamID.length > 1) {
          let duplicateCheck = false;
          const fileNameMap: Record<string, number> = {};
          selectedRows.forEach((item: any) => {
            const name = item.DownloadFileName?.toLowerCase();
            if (fileNameMap[name]) {
              duplicateCheck = true;
            } else {
              fileNameMap[name] = 1;
            }
          });

          if (duplicateCheck) {
            setDialogProps({
              dialogTitle: "Notification",
              contentText:
                "Please note that your Selection Criteria contains duplicate files.Downloaded Duplicate files will be renamed.",
              confirmText: "OK",
              closeText: "Cancel",
              onConfirm: handleDownloadMultipleFiles,
            });
            setDialogOpen(true);
          } else {
            handleDownloadMultipleFiles();
          }
        }
      } else if (selectedRows.length === 0) {
        showSnackbar("Please select the files to Zip and Download", true);
      } else {
        showSnackbar(
          "Please select more than one file to Zip and Download",
          true
        );
      }
    }
  };

  const handleDownloadMultipleFiles = async () => {
    try {
      if (gridRef.current) {
        const selectedRows = gridRef.current.api.getSelectedRows();
        let multiFileDownload = null;
        if (selectedRows.length > 1) {
          let documentStreamID: number[] = [];

          selectedRows.forEach((item: any) => {
            documentStreamID.push(item.DocumentStreamID);
          });

          if (documentStreamID.length > 1) {
            multiFileDownload = {
              SearchText: documentStreamID.toString(),
              contextName: LocalStorageUtil.getItem("contextName")?.toString(),
            };
          }
        }

        setLoading(true);
        const response = await multipleDownloadFile(multiFileDownload);

        if (response.status === 200) {
          const data = response.data;
          const contentType = response.headers["content-type"];
          const fileName = "documents.zip";

          const linkElement = document.createElement("a");

          const blob = new Blob([data], { type: contentType });
          const url = window.URL.createObjectURL(blob);
          linkElement.href = url;
          linkElement.setAttribute("download", fileName);

          const clickEvent = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: false,
          });
          linkElement.dispatchEvent(clickEvent);
        }

        if (response) {
          showSnackbar("Documents downloaded successfully");
          clearSelectedRows();
        } else {
          showSnackbar("Unable to download file !", true);
        }
        setDialogOpen(false);
      }
    } catch (error) {
      showSnackbar("Something went wrong ! Please try again.", true);
    } finally {
      setDialogOpen(false);
      setLoading(false);
    }
  };

  const fileDownload = async (params: any) => {
    const objDownloadFile = {
      documentStreamID: params.DocumentStreamID,
      contextName: LocalStorageUtil.getItem("contextName")?.toString(),
    };

    try {
      setLoading(true);
      const response = await downloadFile(objDownloadFile);

      if (response.status === 200) {
        const data = response.data;
        const contentType = response.headers["content-type"];

        const linkElement = document.createElement("a");

        const blob = new Blob([data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        linkElement.href = url;
        linkElement.setAttribute(
          "download",
          params.ProjectDocumentId + params.FileType
        );

        const clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        linkElement.dispatchEvent(clickEvent);
      }

      if (response) {
        showSnackbar("Documents downloaded successfully");
      } else {
        showSnackbar("Unable to download file !", true);
      }

      setDialogOpen(false);
    } catch (error) {
      showSnackbar("Something went wrong !!!", true);
    } finally {
      setDialogOpen(false);
      setLoading(false);
    }
  };

  const viewDocument = (rowData: any) => {
    const id = rowData.DocumentStreamID;
    const encodedId = btoa(id);
    const fileName = rowData.DownloadFileName.replace(/\.[^/.]+$/, "");
    const url = !urlConfig.isDeployed
      ? `/documentviewer/${encodedId}?FileName=${fileName}`
      : `/docdistrov2/documentviewer/${encodedId}?FileName=${fileName}`;
    popupCenter(url, "Document Viewer", 1100, 550);
  };

  const popupCenter = (url: string, title: string, w: number, h: number) => {
    const dualScreenLeft = window.screenLeft ?? window.screenX ?? 0;
    const dualScreenTop = window.screenTop ?? window.screenY ?? 0;

    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      window.screen.width;

    const height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      window.screen.height;

    const left = width / 3 - w / 3 + dualScreenLeft;
    const top = height / 3 - h / 3 + dualScreenTop;
    const newWindow = window.open(
      url,
      title,
      `readonly=true, scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`
    );
    if (newWindow) {
      newWindow.focus();
    }
  };

  const infoDocument = (rowData: any) => {
    setSelectedDocument(rowData);
    toggleDrawer(true)();
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  // Helper function to extract metadata fields
  const extractMetadataFields = (listSearchStaticModel: any[]) => {
    if (listSearchStaticModel.length === 0) return [];

    const firstItem = listSearchStaticModel[0];
    const extractedFields: { key: string; value: string }[] = [];

    firstItem.metadataviewModel.forEach((field: any) => {
      const fieldName = field.field;
      const fieldValues = listSearchStaticModel
        .map((item: any) => {
          const fieldItem = item.metadataviewModel.find(
            (f: any) => f.field === fieldName
          );
          return fieldItem ? fieldItem.value : "";
        })
        .join("/, ");
      extractedFields.push({ key: fieldName, value: fieldValues });
    });

    return extractedFields;
  };

  // Helper function to extract thumbnail fields
  const extractThumbnailFields = (
    objSearch: any,
    listSearchStaticModel: any[]
  ) => {
    if (!objSearch) return [];

    const extractedFields: { key: string; value: string }[] = [];

    objSearch.searchViewStaticModel.forEach((field: any) => {
      const fieldValues = listSearchStaticModel
        .map(() => {
          return field ? field.thumbnail : "";
        })
        .join(", ");
      extractedFields.push({ key: "Thumbnail", value: fieldValues });
    });

    return extractedFields;
  };

  // Helper function to fetch metadata and thumbnails
  const fetchMetadataAndThumbnails = async (
    payload: CompareMetaDataRequestModel,
    thumbnailPayload: FileDownloadRequestModel,
    setFields: (fields: any[]) => void,
    setthumbnail: (thumbnails: any[]) => void,
    setLoading: (loading: boolean) => void
  ) => {
    try {
      setLoading(true);
      const response = await getCompareMetaData(payload);
      const { listSearchStaticModel = [] } = response;

      // Extract metadata fields
      const extractedFields = extractMetadataFields(listSearchStaticModel);
      setFields(extractedFields);

      // Fetch and extract thumbnails
      try {
        const thumbnailData = await getFileDownload(thumbnailPayload);
        const { objSearch = [] } = thumbnailData;
        const extractedThumbnails = extractThumbnailFields(
          objSearch,
          listSearchStaticModel
        );
        setthumbnail(extractedThumbnails);
      } catch (error) {
        console.error("Error fetching thumbnails:", error);
      }
    } catch (error) {
      console.error("Error fetching metadata:", error);
    } finally {
      setLoading(false);
    }
  };

  const metadataCompare = async () => {
    if (!gridRef.current) return;

    const selectedRows = gridRef.current.api.getSelectedRows();
    if (selectedRows.length <= 1) {
      showSnackbar("Please select two or more documents to compare", true);
      return;
    }

    const documentStreamID: number[] = selectedRows.map(
      (item: any) => item.DocumentStreamID
    );

    const payload: CompareMetaDataRequestModel = {
      sortOrder: 0,
      currentPage: 1,
      noOfRecords: 5,
      SearchText: documentStreamID.toString(),
      AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
      QueueType: QueueType,
      businessUnitID: Number(LocalStorageUtil.getItem("businessUnitId")),
      contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
    };

    const advanceDocumentViewObj: AdvanceDocumentViewObj = {
      contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
    };

    const thumbnailPayload: FileDownloadRequestModel = {
      AdvanceDocumentViewObj: advanceDocumentViewObj,
      fileObj: documentStreamID,
    };

    setFields([]);
    setthumbnail([]);

    await fetchMetadataAndThumbnails(
      payload,
      thumbnailPayload,
      setFields,
      setthumbnail,
      setLoading
    );

    setDialogOpenState(true);
  };

  const handlePopupClose = () => {
    setDialogOpenState(false);
  };

  const handleSearchKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearchSubmit();
    }
  };

  //Close Confirmation Delete Dialog
  const closeConfirmationDialogbox = (deleted: any) => {
    setdeleteConfirmationDialogOpen(false);
    setDeleteDocumentData(null);
    if (deleted) {
      handleSearchSubmit();
    }
  };

  //Close Reprocess SubSystem Dialog
  const closeReprocessSubSystemDialogbox = (isCancelClick: boolean) => {
    setReprocessSubSystemOpen(false);
    setReprocessSubSystemOpenData(null);
    if (isCancelClick) {
      handleSearchSubmit();
    }
  };

  //Close Reprocess FD Dialog
  const closeReprocessFDDialogbox = (isCancelClick: boolean) => {
    setReprocessFDOpen(false);
    setReprocessFDOpenData(null);
    if (isCancelClick) {
      handleSearchSubmit();
    }
  };

  //Close Reprocess E-Delivery Dialog
  const closeReprocessEDeliveryDialogbox = (isCancelClick: boolean) => {
    setReprocessEDeliveryOpen(false);
    setReprocessEDeliveryOpenData(null);
    if (isCancelClick) {
      handleSearchSubmit();
    }
  };

  const handleQueueTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setQueueType(Number(event.target.value));
  };

  useEffect(() => {
    if (gridApi) {
      gridApi.refreshCells({ force: true }); // Force refresh all cells
    }
  }, [QueueType, gridApi]);

  // Open Upload Files Pop up
  const handelUploadFiles = (rowData: any, value: number) => {
    setUploadFilesOpen(true);
    setUploadFilesData(rowData);
  };

  // Close Upload Files Pop up
  const closeUploadFiles = (isCancelClick: boolean) => {
    setUploadFilesOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Open Add Notes Pop up
  const handleAddNotes = (rowData: any) => {
    setAddNotesOpen(true);
    setAddNotesData(rowData);
  };

  // Close Add Notes Pop up
  const closeAddNotes = (isCancelClick: boolean, tabValue?: number) => {
    setAddNotesOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  //Open Rename Pop up
  const handleRename = (rowData: any, isButtonClick: boolean = true) => {
    if (!isButtonClick) {
      setRenamePopupOpen(true);
      setRenameData(rowData);
    } else if (gridRef.current) {
      const selectedRows = gridRef.current?.api.getSelectedRows();
      if (selectedRows.length === 0 || selectedRows.length > 1) {
        showSnackbar("Please select one document", true);
        return;
      } else {
        setRenamePopupOpen(true);
        setRenameData(selectedRows[0]);
      }
    }
  };

  //Close Rename Pop up
  const closeRenamePopup = (isCancelClick: boolean) => {
    setRenamePopupOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  //Open Reject Pop up
  const handleReject = (rowData: any) => {
    setLoading(true);
    try {
      let advanceSearchViewModel: any[] = [];
      if (gridRef.current) {
        let selectedRows = gridRef.current.api.getSelectedRows();
        if (Array.isArray(selectedRows) && selectedRows.length > 0) {
          selectedRows.forEach((element: any) => {
            const objRejectFile: any = {
              CheckBoxDocumentId: element.DocumentID,
              CheckBoxDocumentStreamId: element.DocumentStreamID,
              AccepectId: element.childAcceptedId,
              DocumentStatus: element.DocumentStatus,
              AccntId: Number(LocalStorageUtil.getItem("accountId")) || 0,
              UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
              Remarks: "",
              ContextName: LocalStorageUtil.getItem("contextName") ?? "",
              QueueType: QueueType,
            };
            advanceSearchViewModel.push(objRejectFile);
          });
        } else {
          const objRejectFile: any = {
            CheckBoxDocumentId: rowData.DocumentID,
            CheckBoxDocumentStreamId: rowData.DocumentStreamID,
            AccepectId: rowData.childAcceptedId,
            DocumentStatus: rowData.DocumentStatus,
            AccntId: Number(LocalStorageUtil.getItem("accountId")) || 0,
            UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
            Remarks: "",
            ContextName: LocalStorageUtil.getItem("contextName") ?? "",
            QueueType: QueueType,
          };
          advanceSearchViewModel.push(objRejectFile);
        }
      } else {
        const objRejectFile: any = {
          CheckBoxDocumentId: rowData.DocumentID,
          CheckBoxDocumentStreamId: rowData.DocumentStreamID,
          AccepectId: rowData.childAcceptedId,
          DocumentStatus: rowData.DocumentStatus,
          AccntId: Number(LocalStorageUtil.getItem("accountId")) || 0,
          UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
          Remarks: "",
          ContextName: LocalStorageUtil.getItem("contextName") ?? "",
          QueueType: QueueType,
        };
        advanceSearchViewModel.push(objRejectFile);
      }

      if (advanceSearchViewModel.length > 0) {
        setRejectPopupOpen(true);
        setRejectData(advanceSearchViewModel);
      }
    } catch (error) {
      console.log("Error in handleReject", error);
    } finally {
      setLoading(false);
    }
  };

  //Close Reject Pop up
  const closeRejectPopup = (isCancelClick: boolean, tabValue?: number) => {
    setRejectPopupOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Close Move to Preflight Pop up
  const closeMoveToPreflight = (isCancelClick: boolean) => {
    setMoveToPreflightOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Open Move to Final Folder, Trigger Proof WF, Trigger Prod WF Pop up
  const moveToFinalFolder = async (
    rowData: any,
    value: number,
    status: number
  ) => {
    try {
      let PreworkDetails: any[] = [];
      setContextMenuType(status);
      if (status === 1) {
        // To Final Folder
        setMoveToFinalPopupTitle("Move to Final");
      } else if (status === 2) {
        // Trigger proof WF
        setMoveToFinalPopupTitle("Trigger Proof Workflow");
      } else if (status === 3) {
        // Trigger proof WF
        setMoveToFinalPopupTitle("Trigger Prod Workflow");
      }
      if (value === 0) {
        //Parent
        if (gridRef.current) {
          let selectedRows = gridRef.current.api.getSelectedRows();
          if (selectedRows.length > 0) {
            selectedRows.forEach((element: any) => {
              const objMoveToFinalFolder: any = {
                ParentDocumentID: element.DocumentID,
                DocumentStreamId: element.DocumentStreamID,
                AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
                UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
                FinalDocumentId: element.FinalDocID,
                childFileName: element.DownloadFileName,
                ContextName: LocalStorageUtil.getItem("contextName") ?? "",
                individualFilename: element.DownloadFileName,
                toPreflightZipName: element.ToPreflightZipName,
              };
              PreworkDetails.push(objMoveToFinalFolder);
            });
          } else {
            const objMoveToFinalFolder: any = {
              ParentDocumentID: rowData.DocumentID,
              DocumentStreamId: rowData.DocumentStreamID,
              AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
              UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
              FinalDocumentId: rowData.FinalDocID,
              childFileName: rowData.DownloadFileName,
              ContextName: LocalStorageUtil.getItem("contextName") ?? "",
              individualFilename: rowData.DownloadFileName,
              toPreflightZipName: rowData.ToPreflightZipName,
            };
            PreworkDetails.push(objMoveToFinalFolder);
          }
          if (PreworkDetails.length > 0) {
            setMoveToFinalFolderOpen(true);
            setMoveToFinalFolderData(PreworkDetails);
          }
        }
      }
    } catch (error) {
      console.error("Error in moveToFinalFolder", error);
    }
  };

  // Close Move to Final Folder, Trigger Proof WF, Trigger Prod WF Pop up
  const closeMoveToFinalFolder = (isCancelClick: boolean) => {
    setMoveToFinalFolderOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Close Reprocess Send to Preflight Pop up
  const closeReprocessSendToPreflight = (isCancelClick: boolean) => {
    setReprocessSendToPreflightOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Open Move to Preflight Pop up
  const moveToPreflight = (rowData: any, value: number) => {
    try {
      let objMoveToPreflight: any = {
        PreworkDetails: [],
        InstructionId: undefined,
        ToPreflighJobNo: undefined,
        ReprocessDocumentStatus: undefined,
        IsCheckClient: undefined,
        ContextName: LocalStorageUtil.getItem("contextName") ?? "",
      };
      if (value === 0) {
        if (gridRef.current) {
          let selectedRows = gridRef.current.api.getSelectedRows();
          let PreworkDetails: any[] = [];
          if (selectedRows.length > 0) {
            selectedRows.forEach((element: any) => {
              if (element.DocumentStatus !== 20) {
                const preworkDetail: any = {
                  ParentDocumentID: element.DocumentID,
                  ParentDocumentStreamID: element.DocumentStreamID,
                  ChildFileName: element.DownloadFileName,
                  AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
                  FromPreflightJobNumber: element.FromPreflightJobNumber,
                  FinalDocumentId: element.FinalDocID,
                  ContextName: LocalStorageUtil.getItem("contextName") ?? "",
                  ToPreflightJobNumber: element.ToPreflightJobNumber,
                  UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
                  individualFilename: element.DownloadFileName,
                  toPreflightZipName: element.ToPreflightZipName,
                };
                PreworkDetails.push(preworkDetail);
                objMoveToPreflight = {
                  PreworkDetails: PreworkDetails,
                  InstructionId: undefined,
                  ToPreflighJobNo: element.ToPreflightJobNumber,
                  ReprocessDocumentStatus: element.DocumentStatus,
                  ContextName: LocalStorageUtil.getItem("contextName") ?? "",
                };
              } else if (rowData.parentDocumentStatus === 6) {
                selectedRows.forEach((element: any) => {
                  const preworkDetail: any = {
                    ParentDocumentID: element.DocumentID,
                    ParentDocumentStreamID: element.DocumentStreamID,
                    ChildFileName: element.DownloadFileName,
                    AccountId:
                      Number(LocalStorageUtil.getItem("accountId")) || 0,
                    FromPreflightJobNumber: element.FromPreflightJobNumber,
                    FinalDocumentId: element.FinalDocID,
                    ContextName: LocalStorageUtil.getItem("contextName") ?? "",
                    ToPreflightJobNumber: element.ToPreflightJobNumber,
                    UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
                    individualFilename: element.DownloadFileName,
                    toPreflightZipName: element.ToPreflightZipName,
                  };
                  PreworkDetails.push(preworkDetail);
                  objMoveToPreflight = {
                    PreworkDetails: PreworkDetails,
                    InstructionId: undefined,
                    ToPreflighJobNo: element.ToPreflightJobNumber,
                    ReprocessDocumentStatus: element.DocumentStatus,
                    ContextName: LocalStorageUtil.getItem("contextName") ?? "",
                  };
                });
              }
            });
            setMoveToPreflightOpen(true);
            setMoveToPreflightData(objMoveToPreflight);
          } else {
            const preworkDetail: any = {
              ParentDocumentID: rowData.DocumentID,
              ParentDocumentStreamID: rowData.DocumentStreamID,
              ChildFileName: rowData.DownloadFileName,
              AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
              FromPreflightJobNumber: rowData.FromPreflightJobNumber,
              FinalDocumentId: rowData.FinalDocID,
              ContextName: LocalStorageUtil.getItem("contextName") ?? "",
              ToPreflightJobNumber: rowData.ToPreflightJobNumber,
              UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
              individualFilename: rowData.DownloadFileName,
              toPreflightZipName: rowData.ToPreflightZipName,
            };
            PreworkDetails.push(preworkDetail);
            objMoveToPreflight = {
              PreworkDetails: PreworkDetails,
              InstructionId: undefined,
              ToPreflighJobNo: rowData.ToPreflightJobNumber,
              ReprocessDocumentStatus: rowData.DocumentStatus,
              ContextName: LocalStorageUtil.getItem("contextName") ?? "",
            };
            setMoveToPreflightOpen(true);
            setMoveToPreflightData(objMoveToPreflight);
          }
        }
      }
    } catch (error) {
      console.error("Error in moveToPreflight", error);
    }
  };

  return (
    <div style={{ overflow: "hidden" }}>
      <NavigationBar
        menuTitle="Search"
        screenTitle=""
        title="List Search"
        text="List Search"
      />
      <Row style={{ marginLeft: "2vh" }}>
        <Col xs={12}>
          <Box>
            <div>
              <div>
                <div>
                  <div>
                    <Box
                      component="form"
                      sx={{ "& .MuiTextField-root": { m: 1, width: "100ch" } }}
                      noValidate
                      autoComplete="off"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "1em",
                        }}
                      >
                        <InputLabel
                          htmlFor="list-field"
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                            color: "var(--text-color)",
                            display: "inline-block !important",
                            marginBottom: "5px !important",
                            fontWeight: 600,
                            fontSize: "11px",
                            marginLeft: "7px",
                          }}
                        >
                          Field
                        </InputLabel>
                        <InputLabel
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                            color: "var(--text-color)",
                            display: "inline-block !important",
                            marginBottom: "5px !important",
                            fontWeight: 600,
                            fontSize: "11px",
                            marginLeft: "20ch",
                          }}
                        >
                          Value
                        </InputLabel>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <select
                          id="list-field"
                          value={selectedFieldValue}
                          style={{
                            paddingTop: "0px",
                            backgroundColor: "white",
                            display: "inline-block !important",
                            alignItems: "center",
                            width: "23ch",
                            marginLeft: "6px",
                            height: "25px",
                            fontSize: "11px",
                          }}
                          onChange={handleFieldChange}
                        >
                          <option aria-label="None" value="">
                            Select
                          </option>
                          {categories.map((category, index) => (
                            <optgroup key={index} label={category.label}>
                              {" "}
                              {/* NOSONAR */}
                              {category.options.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </optgroup>
                          ))}
                        </select>
                        {!isDateField ? (
                          <>
                            <TextField
                              variant="outlined"
                              fullWidth
                              style={{
                                paddingTop: "0px",
                                backgroundColor: "white",
                                display: "none",
                                alignItems: "center",
                                width: "47ch",
                                marginLeft: "15px",
                                padding: "2px",
                              }}
                              InputProps={{
                                style: {
                                  height: "24px",
                                  fontSize: "11x",
                                },
                              }}
                              name="search"
                              id="txtSimpleSearch"
                              value={txtSearch}
                              onChange={handleSearchChange}
                            >
                              <MenuItem style={{ fontSize: "11px" }}></MenuItem>
                            </TextField>
                            <input
                              type="text"
                              id="filter-text-box"
                              data-testid="filter-text-box-list-search"
                              value={txtSearch}
                              style={{
                                width: "25ch",
                                height: "2.4em",
                                paddingLeft: ".1em",
                                marginBottom: ".1em",
                                marginLeft: "1em",
                                fontSize: "11px",
                              }}
                              onInput={handleSearchChange}
                              onKeyDown={handleSearchKeyPress}
                            />
                          </>
                        ) : (
                          <Form.Control
                            type="date"
                            placeholder="From Date"
                            name="fromdate"
                            max={new Date().toISOString().split("T")[0]}
                            value={
                              startDate
                                ? startDate.toISOString().split("T")[0]
                                : ""
                            }
                            onChange={(e) =>
                              setStartDate(new Date(e.target.value))
                            }
                            style={{
                              padding: ".3em",
                              width: "10%",
                              fontSize: "14px",
                              borderRadius: "0",
                              border: "1px solid #ccc",
                              borderColor: "black",
                              marginTop: ".1em",
                              marginLeft: "1em",
                            }}
                          />
                        )}
                        <div style={{ marginLeft: "5em", display: "ruby" }}>
                          {
                            <>
                              {isPagePermission(
                                "AllowDownstream",
                                "ListSearch",
                                1402
                              ) &&
                                LocalStorageUtil.getItem("contextName") ===
                                  "DocDistro_BrightHouseFinancials" && (
                                  <Form.Check
                                    id="downstream"
                                    type="radio"
                                    label="Downstream"
                                    radioGroup="queueType"
                                    style={{
                                      marginRight: "10px",
                                      color: "var(--text-color)",
                                    }}
                                    checked={QueueType === 2}
                                    onChange={handleQueueTypeChange}
                                    value="2"
                                  />
                                )}
                              {isPagePermission(
                                "AllowPrework",
                                "ListSearch",
                                1403
                              ) &&
                                LocalStorageUtil.getItem("contextName") ===
                                  "DocDistro_BrightHouseFinancials" && (
                                  <Form.Check
                                    data-testid="queue-type-prework"
                                    id="prework"
                                    type="radio"
                                    label="Prework"
                                    radioGroup="queueType"
                                    style={{
                                      marginRight: "10px",
                                      color: "var(--text-color)",
                                    }}
                                    checked={QueueType === 1}
                                    onChange={handleQueueTypeChange}
                                    value="1"
                                  />
                                )}
                            </>
                          }
                        </div>
                      </div>
                      {resetErrorMsg && (
                        <Typography
                          color="error"
                          variant="body2"
                          style={{
                            marginBottom: "10px",
                            marginLeft: "28ch",
                            color: "var(--aggrid-text-color)",
                          }}
                        >
                          Please enter the text to search
                        </Typography>
                      )}
                      <div
                        style={{
                          color: "var(--aggrid-text-color)",
                          marginLeft: "5px",
                          fontSize: "11px",
                        }}
                      >
                        <InfoIcon /> Enter Values as comma or space separated
                        values.
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "2px",
                          marginTop: "-.1em",
                          width: "100%",
                        }}
                      >
                        <div className="col-sm-6">
                          <Button
                            variant="outlined"
                            type="button"
                            onClick={handleSearchSubmit}
                            color="primary"
                            className="button"
                          >
                            Search
                          </Button>
                          <Button
                            color="primary"
                            type="button"
                            variant="outlined"
                            className="button"
                            onClick={handleReset}
                            aria-label="delete"
                          >
                            Reset
                          </Button>
                        </div>
                        <div
                          className="col-sm-6"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            width: "50%",
                          }}
                        >
                          {deleteRightShow &&
                          isPagePermission(
                            "Allow Metadata Compare",
                            "ListSearch",
                            52
                          ) ? (
                            <Button
                              variant="contained"
                              id="delete"
                              size="small"
                              onClick={metadataCompare}
                              className="button metadata-button"
                            >
                              Metadata compare
                            </Button>
                          ) : null}
                          {LocalStorageUtil.getItem("isSuperAdmin") === "1" &&
                            LocalStorageUtil.getItem("contextName") ===
                              "DocDistro_BrightHouseFinancials" && (
                              <Button
                                variant="contained"
                                id="delete"
                                size="small"
                                onClick={handleRename}
                                className="button"
                              >
                                Rename
                              </Button>
                            )}
                          {deleteRightShow &&
                            isPagePermission(
                              "Allow Delete",
                              "ListSearch",
                              56
                            ) && (
                              <Button
                                variant="contained"
                                id="delete"
                                size="small"
                                onClick={deleteSelectetdDocuments}
                                className="button"
                              >
                                Delete
                              </Button>
                            )}
                          {zipDownload && (
                            <Button
                              id="zipanddownload"
                              variant="contained"
                              size="small"
                              onClick={downloadSelectedFiles}
                              className="button download-zip-button"
                            >
                              Zip and Download
                            </Button>
                          )}
                        </div>
                      </div>
                    </Box>
                  </div>
                </div>
                <div className={styles.buttonContainer}></div>
                <div
                  className="ag-theme-quartz-dark"
                  style={{
                    height: deleteRightShow === true ? "66vh" : "65vh",
                    width: "99%",
                    marginTop: ".1vh",
                  }}
                >
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={rowData}
                    onGridReady={onGridReady}
                    ref={gridRef}
                    pagination={true}
                    paginationPageSize={defaulPageSize}
                    paginationPageSizeSelector={pageSizeSelector}
                    gridOptions={{
                      rowSelection: {
                        mode: "multiRow",
                        checkboxes: true,
                        headerCheckbox: true,
                        enableClickSelection: false,
                      },
                    }}
                    headerHeight={30}
                    rowHeight={20}
                    domLayout="normal"
                    rowGroupPanelShow="always"
                    pivotPanelShow="always"
                    overlayNoRowsTemplate={
                      '<span class="ag-overlay-loading-center">No rows to show</span>'
                    }
                    loading={!rowData || showLoader}
                    loadingOverlayComponent={CustomLoadingOverlay}
                    context={{ QueueType }}
                  />

                  <ConfirmationDialog
                    open={dialogOpen}
                    onClose={handleDialogClose}
                    onConfirm={dialogProps.onConfirm}
                    contentText={dialogProps.contentText}
                    closeText={dialogProps.closeText}
                    confirmText={dialogProps.confirmText}
                    dialogTitle={dialogProps.dialogTitle}
                  />

                  <div>
                    <InfoDrawer
                      isOpen={drawerOpen}
                      onClose={toggleDrawer(false)}
                      title="Document Info"
                      tabLabels={["Information", "Version History"]}
                      selectedDocument={selectedDocument}
                    />
                  </div>
                </div>
                <div>
                  <BootstrapDialog
                    onClose={handlePopupClose}
                    aria-labelledby="customized-dialog-title"
                    open={dialogOpenState}
                    PaperProps={{ sx: { maxWidth: "100%", height: "900px" } }}
                  >
                    <DialogTitle
                      className={styles.dialogtitle}
                      sx={{
                        m: 0,
                        p: 1,
                        fontWeight: "bold",
                        fontSize: "14px",
                        lineHeight: "1.5",
                        padding: "1em",
                        backgroundColor: "var(--primary-color)",
                        color: "var(--aggrid-text-color)",
                      }}
                      id="customized-dialog-title"
                    >
                      Metadata Compare
                    </DialogTitle>
                    <IconButton
                      aria-label="close"
                      onClick={handlePopupClose}
                      sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                        padding: "0px",
                      })}
                      style={{ color: "var(--aggrid-text-color)" }}
                    >
                      <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                      <div
                        className="col-sm-12 pull-left"
                        style={{ width: "100%", height: "100%" }}
                      >
                        <div
                          className="table-container"
                          style={{
                            width: "100%",
                            height: "100%",
                            overflowX: "auto",
                            overflowY: "auto",
                          }}
                        >
                          <table
                            style={{
                              marginBottom: "0",
                              border: "1px solid #8eb4d8",
                              width: "max-content", // Ensures horizontal scroll if needed
                              minWidth: "100%", // Prevents column overlap
                              color: "#212529",
                              tableLayout: "fixed",
                              borderCollapse: "separate",
                              borderSpacing: "3px", // Adds gap between columns
                            }}
                          >
                            <tbody>
                              {/* Table Header */}
                              <tr>
                                <th
                                  style={{
                                    minWidth: "15em",
                                    maxWidth: "15em",
                                    paddingLeft: "1em",
                                    position: "sticky",
                                    left: "0",
                                    background: "#fff",
                                    zIndex: "2",
                                    fontSize: "12px",
                                  }}
                                >
                                  Thumbnail
                                </th>
                                {
                                  thumbnail.length === 0
                                    ? fields[0]?.value
                                        .split(",")
                                        .map((_, index) => (
                                          <td
                                            key={index}
                                            style={{
                                              background: "#f9f9f9",
                                              border: "0px",
                                              minWidth: "25em",
                                              maxWidth: "25em",
                                              overflow: "hidden",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {" "}
                                            {/* NOSONAR */}
                                            <p style={{ marginLeft: "2em" }}>
                                              N/A
                                            </p>
                                          </td>
                                        )) //NOSONAR
                                    : thumbnail.map(
                                        (item1, subIndex) =>
                                          item1.value.split(",").map(
                                            (value, valueIndex) =>
                                              subIndex === 0 && (
                                                <td
                                                  key={valueIndex}
                                                  style={{
                                                    background: "#8eb4d8",
                                                    border: "0px",
                                                    minWidth: "25em",
                                                    maxWidth: "25em",
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  {/* NOSONAR */}
                                                  <img
                                                    style={{
                                                      marginLeft: "40%",
                                                    }}
                                                    width="80px"
                                                    height="80px"
                                                    alt=""
                                                    src={`data:image/jpeg;base64,${value}`}
                                                  />
                                                </td>
                                              )
                                          ) //NOSONAR
                                      ) //NOSONAR
                                }
                              </tr>

                              {/* Table Rows */}
                              {
                                fields.map((item1, subIndex) => (
                                  <tr key={subIndex}>
                                    <th
                                      style={{
                                        minWidth: "15em",
                                        maxWidth: "15em",
                                        paddingLeft: "1em",
                                        position: "sticky",
                                        left: "0",
                                        background: "#fff",
                                        zIndex: "2",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {/* NOSONAR */}
                                      <span>{item1.key}</span>
                                    </th>
                                    {item1.value
                                      .split("/,")
                                      .map((value, valueIndex) => (
                                        <td
                                          key={valueIndex}
                                          style={{
                                            background:
                                              subIndex % 2 === 0
                                                ? "#f9f9f9"
                                                : "#8eb4d8",
                                            border: "0px",
                                            minWidth: "25em",
                                            maxWidth: "25em",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            padding: ".5em",
                                            fontSize: "11px",
                                          }}
                                        >
                                          {/* NOSONAR */}
                                          <Tooltip title={value.trim()}>
                                            <span>{value.trim()}</span>
                                          </Tooltip>
                                        </td>
                                      ))}
                                  </tr>
                                )) /* NOSONAR */
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </DialogContent>
                  </BootstrapDialog>
                </div>
              </div>
            </div>
            {assetHistoryOpen && (
              <AssetHistory
                isOpen={assetHistoryOpen}
                onClose={closeAssetHistory}
                title=""
                selectedData={assetHistoryData}
              />
            )}
            {/* Delete Confirmation dialogbox */}
            {deleteConfirmationDialogOpen && (
              <ConfirmationAlert
                isOpen={deleteConfirmationDialogOpen}
                onClose={(e) => closeConfirmationDialogbox(e)}
                title="Delete Confirmation"
                selectedData={deleteDocumentData}
                isArf={isArfMessage}
                screen="DownstreamSummary"
              />
            )}

            {/* Reprocess SubSystem dialogbox */}
            {reprocessSubSystemOpen && (
              <DownstreamSubSystemReprocessPopup
                isOpen={reprocessSubSystemOpen}
                onClose={closeReprocessSubSystemDialogbox}
                title="Reprocess"
                selectedData={reprocessSubSystemOpenData}
                documentStatusFlag={false}
              />
            )}

            {/* Reprocess Downsample and Preflight  */}
            {reprocessFDOpen && (
              <DownstreamFDReprocesspopup
                isOpen={reprocessFDOpen}
                onClose={closeReprocessFDDialogbox}
                title="Reprocess"
                selectedData={reprocessFDOpenData}
                value={1}
              />
            )}

            {/* Reprocess EDelivery */}
            {reprocessEDeliveryOpen && (
              <DownstreamFDReprocesspopup
                isOpen={reprocessEDeliveryOpen}
                onClose={closeReprocessEDeliveryDialogbox}
                title="Reprocess"
                selectedData={reprocessEDeliveryOpenData}
                value={2}
              />
            )}
            {/* Upload Files Dialog */}
            {uploadFilesOpen && (
              <FileUploads
                isOpen={uploadFilesOpen}
                onClose={closeUploadFiles}
                title="Upload Files"
                selectedData={uploadFilesData}
                screenType="advanceSearch"
              />
            )}

            {/* Add Notes Dialog */}
            {addNotesOpen && (
              <AddNotes
                isOpen={addNotesOpen}
                onClose={closeAddNotes}
                title="Add Notes"
                selectedData={addNotesData}
                screenType="PreworkDetails"
              />
            )}

            {/* Rename popup */}
            {renamePopupOpen && (
              <RenamePopup
                isOpen={renamePopupOpen}
                onClose={closeRenamePopup}
                title="Rename File"
                selectedData={renameData}
              />
            )}

            {/* Reject popup */}
            {rejectPopupOpen && (
              <RejectFile
                isOpen={rejectPopupOpen}
                onClose={closeRejectPopup}
                title="Reject File"
                selectedData={rejectData}
              />
            )}
            {/* Move to Preflight Dialog */}
            {moveToPreflightOpen && (
              <MoveToPreflightPopup
                isOpen={moveToPreflightOpen}
                onClose={closeMoveToPreflight}
                title="Move To Preflight"
                selectedData={moveToPreflightData}
                documentStatus={documentStatusValue}
              />
            )}

            {/* Move to Final Folder Dialog */}
            {moveToFinalFolderOpen && (
              <MoveToFinal
                isOpen={moveToFinalFolderOpen}
                onClose={closeMoveToFinalFolder}
                title={moveToFinalPopupTitle}
                selectedData={moveToFinalFolderData}
                contextMenuType={contextMenuType}
              />
            )}

            {/* Reprocess Send to Preflight Dialog */}
            {reprocessSendToPreflightOpen && (
              <ReprocessSendToPreflight
                isOpen={reprocessSendToPreflightOpen}
                onClose={closeReprocessSendToPreflight}
                title="Reprocess"
                selectedData={reprocessSendToPreflightData}
              />
            )}
          </Box>
        </Col>
      </Row>
    </div>
  );
};

export default ListSearch;
